import { render, staticRenderFns } from "./product-nav.vue?vue&type=template&id=be10ca4c"
import script from "./product-nav.vue?vue&type=script&lang=js"
export * from "./product-nav.vue?vue&type=script&lang=js"
import style0 from "./product-nav.vue?vue&type=style&index=0&id=be10ca4c&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be10ca4c')) {
      api.createRecord('be10ca4c', component.options)
    } else {
      api.reload('be10ca4c', component.options)
    }
    module.hot.accept("./product-nav.vue?vue&type=template&id=be10ca4c", function () {
      api.rerender('be10ca4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/product-nav.vue"
export default component.exports